import { useState } from 'react';
import { AdminHeaderWrapper, FooterLayout, HeaderWrapper, Layout, TableCell, TableLayout } from 'components/Hospital/PaginationForms';
import { adminDiagnosisListHeader, adminDiagnosisListWidth, diagnosisListWidth } from 'constants/pagination';
import { DiagnosisListPaginationProps } from 'models/Hospital/paginationTypes';
import ArrowLineDown from 'assets/Icons/Arrow/ArrowLineDown';
import { LabelSelectButton } from 'components/Common/SortingButton';
import { OtherSortingButton } from 'styles/Global/buttonStyles';
import ArrowLineUp from 'assets/Icons/Arrow/ArrowLineUp';
import NothingDataInPagination from 'pages/Admin/DCK/AddDiagnosisPage/NothingDataInPagination';
import CustomedPagination from 'components/Pagination/CustomedPagination';
import AdminDiagnosisListPaginationTable from './AdminDiagnosisListPaginationTable';
import { getWidthRation } from 'utils/calculateWdith';

const AdminDiagnosisListPagination = ({
    currentPage,
    totalPages,
    pageGroup,
    handlePageGroup,
    handlePageChange,
    currentData,
    initNumber,
    handleSorting,
    sortField,
    sortDirections,
    handleResetButton,
}: DiagnosisListPaginationProps) => {
    const [selectHeader, setSelectHeader] = useState<string>('');

    return (
        <Layout>
            <TableLayout>
                <AdminHeaderWrapper>
                    {adminDiagnosisListHeader.map((name, idx) => {
                        return (
                            <TableCell
                                key={idx}
                                $idx={idx === 2 ? 3 : idx === 3 ? 2 : idx}
                                $width={getWidthRation(adminDiagnosisListWidth[idx])}
                                $type='header'
                                $justifyContent='space-between'
                                hover={setSelectHeader}
                                cellType={name.type !== 'null' && name.type !== 'patientMobile' ? name.type : undefined}
                            >
                                {name.title}
                                {name.type === 'diagnosisDateTime' && (sortField === name.type || selectHeader === 'diagnosisDateTime') && (
                                    <LabelSelectButton onClick={() => handleSorting(name.type)}>{sortDirections[name.type] ? '최신순' : '오래된순'}</LabelSelectButton>
                                )}
                                {(sortField === name.type || selectHeader === name.type) &&
                                    name.type !== 'null' &&
                                    name.type !== 'gradeName' &&
                                    name.type !== 'patientMobile' &&
                                    name.type !== 'diagnosisDateTime' && (
                                        <OtherSortingButton onClick={() => handleSorting(name.type)}>{sortDirections[name.type] ? <ArrowLineUp /> : <ArrowLineDown />}</OtherSortingButton>
                                    )}
                            </TableCell>
                        );
                    })}
                </AdminHeaderWrapper>
                {currentData?.length !== 0 ? (
                    <AdminDiagnosisListPaginationTable currentData={currentData || []} />
                ) : (
                    <NothingDataInPagination initNumber={initNumber} handleResetButton={handleResetButton} />
                )}
            </TableLayout>
            {currentData && totalPages !== 0 && (
                <CustomedPagination currentPage={currentPage} onChangeCurrentPage={handlePageChange} onChangeSectionIdx={handlePageGroup} sectionIndex={pageGroup} totalPages={totalPages} />
            )}
        </Layout>
    );
};

export default AdminDiagnosisListPagination;
